var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPlayer)?_c('div',[_c('video',{attrs:{"id":"videoElement","width":"80%","height":"500px","controls":""}},[_c('source',{attrs:{"src":_vm.videoURL}})])]):_c('div',{staticStyle:{"height":"85vh","display":"flex","justify-content":"center","align-items":"center"}},[_c('h2',[_vm._v("Invalid video url")])])
}
var staticRenderFns = []

export { render, staticRenderFns }